// Hooks
import useDarkMode from '@/utils/hooks/utils/useDarkMode';
import HasSocialProfileMiddleware from '@/utils/hooks/middleware/useHasSocialProfile';

// Components
import LayoutLogged from '@/components/layouts/LayoutLogged';
import Menu from '@/components/composite/Menu';
import MenuMobile from '@/components/composite/MenuMobile';
import { SocialProfileGroupMenu } from '@/components/composite/SocialProfiles/SocialProfileGroupMenu';
import ModalFirstStats from '@/components/composite/Modals/ModalFirstStats';
import TrialRedirection from '@/components/composite/Banners/TrialRedirection';
import { PendoInitialize } from '@/components/tools/Pendo';

const WrapperLogged = ({
    children,
    className,
    bodyWrapperClass
}: {
    children: React.ReactNode;
    className?: string;
    bodyWrapperClass?: string;
}) => {
    const { useAddDarkMode } = useDarkMode();
    useAddDarkMode();

    return (
        <LayoutLogged className={className}>
            <TrialRedirection>
                <HasSocialProfileMiddleware>
                    <LayoutLogged.LeftSide>
                        <Menu />
                        <MenuMobile />
                    </LayoutLogged.LeftSide>
                    <LayoutLogged.Body bodyWrapperClass={bodyWrapperClass}>
                        {children}
                        <ModalFirstStats />
                    </LayoutLogged.Body>
                    <LayoutLogged.RightSide>
                        <SocialProfileGroupMenu />
                    </LayoutLogged.RightSide>
                    <PendoInitialize />
                </HasSocialProfileMiddleware>
            </TrialRedirection>
        </LayoutLogged>
    );
};

export default WrapperLogged;
